import RecipeArticleCard from './RecipeArticleCard';

export default RecipeArticleCard;
